import React from "react";
var __jsx = React.createElement;
import HeroCarousel from './HeroCarousel';
function HeroCarouselAdapter(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  return __jsx(HeroCarousel, {
    heroCarouselData: entry,
    scrollbarWidth: data.scrollbarWidth,
    blurredPageHeroBgImg: data.blurredPageHeroBgImg,
    shouldPreloadImage: data.shouldPreloadImage
  });
}
export default HeroCarouselAdapter;